export const generalState: { [key: string]: any } = {
    leadSource: '',
    leadId: '',
    leadStatus: '',
    armadaCustomerId: '',
    leasmanCustomerId: '',
    type: '',
    creationTimestamp: '',
};
